module.exports = __webpack_public_path__ + "static/example_gantt_chart-1fea1b4570b941c7a7fc13102c2e1599.png";